export default __webpack_public_path__ + "img/register.47292e05.svg";